module.exports = __webpack_public_path__ + "e87fa2e398915a512a777b52ece43062.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/data.png
// module id = 1666
// module chunks = 0